import { brand, lightBrand, palette } from "../theme";

const tone = palette.dark;

const toastStyles = `
  :root {
    --toastify-color-dark: ${tone.panel};
    --toastify-color-progress-dark: ${brand.gold};
    --toastify-text-color-dark: ${tone.textPrimary};
  }
  .Toastify__toast {
    background-color: ${tone.panel} !important;
    color: ${tone.textPrimary} !important;
    border: 1px solid ${tone.borderAccent} !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3) !important;
  }
  .Toastify__toast-body {
    background-color: ${tone.panel} !important;
    color: ${tone.textPrimary} !important;
  }
  .Toastify__progress-bar {
    background-color: ${brand.gold} !important;
  }
  .Toastify__close-button {
    color: ${tone.textPrimary} !important;
  }
  [data-theme="light"] .Toastify__toast {
    background-color: ${palette.light.panel} !important;
    color: ${palette.light.textPrimary} !important;
    border-color: ${palette.light.border} !important;
  }
  [data-theme="light"] .Toastify__toast-body {
    background-color: ${palette.light.panel} !important;
    color: ${palette.light.textPrimary} !important;
  }
  [data-theme="light"] .Toastify__progress-bar {
    background-color: ${lightBrand.primary} !important;
  }
  [data-theme="light"] .Toastify__close-button {
    color: ${palette.light.textSecondary} !important;
  }
`;

export default toastStyles;
